import { v4 as uuidv4 } from 'uuid';

export default {
    state: () => ({
        alerts: [

        ]
    }),
    mutations: {
        addAlert(state, alert) {
            if (Array.isArray(alert.message)) {
              alert.message.forEach(msg => {
                state.alerts.push({
                  message: msg,
                  type: alert.type,
                  id: uuidv4()
                })
              }) 
            } else {
              alert.id = uuidv4()
              state.alerts.push(alert)
            }
        },
        removeImmediately: (state, alertToRemove) => {
            const index = state.alerts.findIndex(alert => alert.id === alertToRemove.id)
            state.alerts.splice(index, 1)
}
    },
    actions: {
        createAlert: ({dispatch}, alert) => {
            if (alert.message.response) {
                dispatch('handleGravyResponseError', alert.message.response)
            } else {
                dispatch('addAlert', alert)
            }
        },
        handleGravyResponseError: ({dispatch}, e) => {
           if (e.data.errors.length > 0)  {
               e.data.errors.forEach(error => {
                  dispatch('addAlert', {
                      type: 'danger',
                      message: error
                  })
               })
           }
        },
        removeAlertImmediately: ({ commit }, alert) => {
            commit('removeImmediately', alert)
        },
        addAlert: ({commit }, alert) => {
            commit('addAlert', alert)
            setTimeout(() => { commit('removeImmediately', alert)}, 5000)
        }
    },
    getters: {
        getAlerts(state, getters) {
            return state.alerts
        }
    },
};
